import { allRegex } from "./regex";

export function esNIE(val: string){
   
    return allRegex.regexNIE.test(val);
}